import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
class CustomerAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formData: {
                name: '',
                surname: '',
                email: '',
                phone: '',
                address: '',
                tax_district: '',
                tax_no: '',
                title: '',
                city_id: '',
                district_id: '',
                is_supplier: '',
                save_parasut: 0,
            },
            cities: [],
            districts: []
        }
    }
    async componentDidMount() {
        const response = await getBranches();
        this.getCities();
        this.setState({ branches: response });
    }
    getCities = async () => {
        const response = await apiCall('get-cities', 'get', null);
        this.setState({ cities: response });
    }

    handleCityChange = async (event) => {
        const city_id = event.target.value;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                city_id: city_id,
                district_id: ""
            },
            districts: []
        }));

        if (city_id) {
            const response = await apiCall(`get-dist/${city_id}`, 'get', null);
            this.setState({ districts: response });
        }
    }
    handleChange = (e) => {
        const { id, type, checked, value } = e.target;

        const inputValue = type === 'checkbox' ? checked : value;
        console.log(inputValue);
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: inputValue
            }
        }));
    };
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const customerFormData = new FormData();
        Object.keys(this.state.formData).forEach(key => {
            customerFormData.append(key, formData[key]);
        });

        try {
            const response = await apiCall('business/customer/add', 'post', customerFormData, { form: e.target });
            this.setState({ loading: false });
            mainHelper.toastMessage(response.status, response.message)
        } catch (e) {
            this.setState({ loading: false });
        }

    }
    checkTaxPayer = async () => {
        try {
            Swal.fire({
                title: 'Sorgulama Yapılıyor...',
                text: 'Lütfen bekleyin, işleminiz devam ediyor.',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });
            const checkGibCredentials = await apiCall('business/customer/check-gib', 'get', null);
            if (!checkGibCredentials.gib_usercode || !checkGibCredentials.gib_password) {
                Swal.close();
                Swal.fire({
                    title: 'Uyarı!',
                    text: 'Gib kullanıcı kodu ve şifre girilmemiş.Ayarlar->işletme ayarları, içerisinden ekledikten sonra tekrar deneyiniz!',
                    icon: 'warning',
                    confirmButtonText: 'Tamam',
                });
                return;
            }
            const response = await apiCall('business/customer/check-taxpayer/' + this.state.formData.tax_no, 'get', null);

            const { unvan, adi, soyadi, vergiDairesi } = response;

            const messages = [];
            if (unvan) messages.push(`Ünvan: ${unvan}`);
            if (adi) messages.push(`Adı: ${adi}`);
            if (soyadi) messages.push(`Soyadı: ${soyadi}`);
            if (vergiDairesi) messages.push(`Vergi Dairesi: ${vergiDairesi}`);
            const text = messages.join('\n');

            if (messages.length === 0) {
                Swal.fire({
                    title: 'Hata!',
                    text: 'Mükellefe ait veri bulunamadı.',
                    icon: 'warning',
                    confirmButtonText: 'Tamam'
                });
            } else {

                Swal.fire({
                    title: 'İşlem tamamlandı!',
                    text: text,
                    icon: 'success',
                    confirmButtonText: 'Tamam'
                });
            }
        } catch (error) {
            Swal.fire({
                title: 'Uyarı!',
                text: 'Veriler alınırken bir hata oluştu.',
                icon: 'error',
                confirmButtonText: 'Tamam'
            });
        }
    }

    render() {
        const { loading, districts, cities } = this.state;
        const { userPermissions } = this.props;
        const userHasNewCustomerPermission = userPermissions.includes('new customer');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Müşteri/Tedarikçi Ekle"
                            Breadcrumb={[
                                { name: "Müşteriler ve Tedarikçiler", navigate: "customers" },
                                { name: "Yeni Müşteri/Tedarikçi", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="body">
                                            <h6>Temel Bilgiler</h6>
                                            <div className="row clearfix">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <select
                                                            className="form-control"
                                                            id="is_supplier"
                                                            onChange={this.handleChange}>
                                                            <option value="">Tip Seçiniz</option>
                                                            <option value="0">Müşteri</option>
                                                            <option value="1">Tedarikçi</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="name"
                                                            className="form-control"
                                                            placeholder="Ad"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="surname"
                                                            className="form-control"
                                                            placeholder="Soyad"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="email"
                                                            className="form-control"
                                                            placeholder="Email"
                                                            type="email"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="phone"
                                                            className="form-control"
                                                            placeholder="Telefon"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <select
                                                            className="form-control"
                                                            id="city_id"
                                                            onChange={this.handleCityChange}>
                                                            <option value="">İl Seçiniz</option>
                                                            {cities && (cities.map(city => (
                                                                <option key={city.id}
                                                                    value={city.id}>{city.name}</option>
                                                            )))}

                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <input
                                                            id="title"
                                                            className="form-control"
                                                            placeholder="Ünvan"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="tax_no"
                                                            className="form-control"
                                                            placeholder="Vergi No"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <textarea
                                                            id="address"
                                                            className="form-control"
                                                            placeholder="Adres"
                                                            onChange={this.handleChange}>
                                                        </textarea>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="form-group">
                                                        <select
                                                            className="form-control"
                                                            id="district_id"
                                                            onChange={this.handleChange}>
                                                            <option value="">İlçe Seçiniz</option>
                                                            {districts && (districts.map(district => (
                                                                <option key={district.id}
                                                                    value={district.id}>{district.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="tax_district"
                                                            className="form-control"
                                                            placeholder="Vergi Dairesi"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input
                                                            id="urn"
                                                            className="form-control"
                                                            placeholder="Fatura Urn Adresi"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    {/*
                                                    <div className="form-group">
                                                        <div className="fancy-checkbox">
                                                            <label htmlFor="save_parasut"
                                                                   className="font-weight-bold text-cyan">

                                                                <input
                                                                    id="save_parasut"
                                                                    type="checkbox"
                                                                    checked={this.state.formData.save_parasut}
                                                                    onChange={this.handleChange}
                                                                />
                                                                <span>Paraşüt'e Kaydet</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    */}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="body">
                                            <div className="row clearfix justify-content-center">
                                                <div className="col-lg-6 col-md-12">

                                                    {loading ? (
                                                        <button className="btn btn-outline-primary btn-block"
                                                            disabled={true}
                                                            style={{ textAlign: "-webkit-center" }}>
                                                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                                                height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                                                        </button>
                                                    ) :
                                                        <button disabled={!userHasNewCustomerPermission}
                                                            className="btn btn-outline-primary btn-block"
                                                            type="submit">
                                                            Kaydet
                                                        </button>}
                                                    {this.state.formData.tax_no && this.state.formData.tax_no.trim() !== "" && (
                                                        <button onClick={this.checkTaxPayer} className="btn btn-outline-warning btn-block" type="button">
                                                            Mükellef Doğrula
                                                        </button>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(CustomerAdd)));
